import HistoricoDetailTable from '@atendimento/detail/historico/components/table/HistoricoDetailTable'
import { css } from '@emotion/react'
import { Flow, Heading, HeadingProps, Text } from 'bold-ui'
import { HLabel } from 'components/HLabel'
import { EvolucaoSubjetivoCiap } from 'graphql/types.generated'
import { isEmpty } from 'util/checks'
import { HistoricoSectionStyles } from 'view/atendimentos/detail/historico/model/model-historico'

export interface MotivoConsultaBoxProps {
  subjetivoCiaps: ReadonlyArray<EvolucaoSubjetivoCiap>
  level?: HeadingProps['level']
}

export default function MotivoConsultaBox(props: Readonly<MotivoConsultaBoxProps>) {
  const { subjetivoCiaps, level = 5 } = props

  if (isEmpty(subjetivoCiaps)) return null

  const styles = createStyles()

  return (
    <Flow direction='vertical' gap={0.5}>
      <Heading level={level} style={styles.motivoHeading}>
        Motivo da consulta
      </Heading>
      <HistoricoDetailTable hasLines>
        <Flow direction='vertical' gap={0}>
          {subjetivoCiaps.map((subjetivoCiap) => (
            <Flow key={subjetivoCiap.id} direction='horizontal' gap={0.5}>
              <Text>
                <Text fontWeight='bold'>
                  {`${subjetivoCiap.ciap.descricao} - ${subjetivoCiap.ciap.codigo}`.toUpperCase()}
                </Text>
                {' (CIAP 2)'}
              </Text>
              {subjetivoCiap.nota && <HLabel title='Observações:'>{subjetivoCiap.nota}</HLabel>}
            </Flow>
          ))}
        </Flow>
      </HistoricoDetailTable>
    </Flow>
  )
}

const createStyles = () => ({
  motivoHeading: css`
    color: ${HistoricoSectionStyles['S'].color};
  `,
  ciapContent: css`
    p:last-child {
      margin-top: 1rem;
    }
  `,
})
